/* tslint:disable */
/* eslint-disable */
/**
 * Altair 2 API
 * API for users, groups, links, etc..
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLoginNextStep200Response
 */
export interface GetLoginNextStep200Response {
    /**
     * acc type
     * @type {string}
     * @memberof GetLoginNextStep200Response
     */
    type?: GetLoginNextStep200ResponseTypeEnum;
    /**
     * status
     * @type {string}
     * @memberof GetLoginNextStep200Response
     */
    status: GetLoginNextStep200ResponseStatusEnum;
}


/**
 * @export
 */
export const GetLoginNextStep200ResponseTypeEnum = {
    Cognito: 'COGNITO',
    Google: 'GOOGLE',
    Microsoft: 'MICROSOFT'
} as const;
export type GetLoginNextStep200ResponseTypeEnum = typeof GetLoginNextStep200ResponseTypeEnum[keyof typeof GetLoginNextStep200ResponseTypeEnum];

/**
 * @export
 */
export const GetLoginNextStep200ResponseStatusEnum = {
    Active: 'ACTIVE',
    Unconfirmed: 'UNCONFIRMED',
    ForceChangePassword: 'FORCE_CHANGE_PASSWORD',
    Disabled: 'DISABLED',
    NotFound: 'NOT_FOUND'
} as const;
export type GetLoginNextStep200ResponseStatusEnum = typeof GetLoginNextStep200ResponseStatusEnum[keyof typeof GetLoginNextStep200ResponseStatusEnum];


/**
 * Check if a given object implements the GetLoginNextStep200Response interface.
 */
export function instanceOfGetLoginNextStep200Response(value: object): value is GetLoginNextStep200Response {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function GetLoginNextStep200ResponseFromJSON(json: any): GetLoginNextStep200Response {
    return GetLoginNextStep200ResponseFromJSONTyped(json, false);
}

export function GetLoginNextStep200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLoginNextStep200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'],
    };
}

export function GetLoginNextStep200ResponseToJSON(json: any): GetLoginNextStep200Response {
    return GetLoginNextStep200ResponseToJSONTyped(json, false);
}

export function GetLoginNextStep200ResponseToJSONTyped(value?: GetLoginNextStep200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'status': value['status'],
    };
}

